/*
 * 3D Owala header behaviour.
 *
 * Two things Dawn does not do on its own:
 *   1. The header sits transparently over the homepage hero until you scroll
 *      or hover it, at which point it takes a solid ground.
 *   2. The mega menu opens on hover, and the panel's artwork follows whichever
 *      child link the pointer is on.
 *
 * Both are progressive: with JS off, the header stays solid and the menu still
 * opens on click, which is Dawn's stock behaviour.
 */
(function () {
  'use strict';

  var SOLID = 'owala-header--solid';
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  // Matches the CSS breakpoint: below it the header stays in normal flow.
  var overlay = document.body.classList.contains('owala-overlay') && DESKTOP.matches;

  var group = document.querySelector('.shopify-section-group-header-group');
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  /* ---------- 1. Transparent over the hero ------------------------------ */

  function measure() {
    if (!overlay || !group) return;
    // The hero is pulled up by exactly the height of the header row, so the
    // announcement bar above it stays in normal flow and keeps its own ground.
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('owala-header-h'.replace(/^/, '--'), h + 'px');
  }

  var solidLocked = false;

  function sync() {
    if (!overlay) return;
    var scrolled = window.scrollY > 8;
    header.classList.toggle(SOLID, scrolled || solidLocked);
  }

  if (overlay) {
    measure();
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', measure);

    header.addEventListener('mouseenter', function () {
      solidLocked = true;
      sync();
    });
    header.addEventListener('mouseleave', function () {
      solidLocked = false;
      sync();
    });
    // Keyboard users get the solid ground too, so focus outlines stay legible.
    header.addEventListener('focusin', function () {
      solidLocked = true;
      sync();
    });
    header.addEventListener('focusout', function () {
      if (!header.contains(document.activeElement)) {
        solidLocked = false;
        sync();
      }
    });
  }

  /* ---------- 2. Hover-driven mega menu --------------------------------- */

  var FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('header-menu > details.mega-menu').forEach(function (details) {
    var host = details.parentElement;
    var panel = details.querySelector('.mega-menu__content');
    var closeTimer;

    function open() {
      if (!FINE_POINTER.matches) return;
      clearTimeout(closeTimer);
      details.open = true;
    }

    function close() {
      if (!FINE_POINTER.matches) return;
      // The panel is absolutely positioned, so it sits outside the trigger's
      // box: the pointer leaves the trigger before it reaches the panel. The
      // delay keeps the panel open across that gap, and entering either the
      // trigger or the panel cancels it.
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.open = false;
      }, 260);
    }

    host.addEventListener('mouseenter', open);
    host.addEventListener('mouseleave', close);

    if (panel) {
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', close);
    }

    // Leaving the header entirely should close it immediately rather than
    // waiting out the grace period.
    if (header) {
      header.addEventListener('mouseleave', function () {
        if (!FINE_POINTER.matches) return;
        clearTimeout(closeTimer);
        details.open = false;
      });
    }

    /* ---------- 3. Artwork follows the hovered child link --------------- */

    var links = details.querySelectorAll('[data-owala-mega-link]');
    var figures = details.querySelectorAll('[data-owala-mega-figure]');
    if (!figures.length) return;

    function show(handle) {
      var matched = false;
      figures.forEach(function (fig) {
        var on = fig.getAttribute('data-owala-mega-figure') === handle;
        fig.classList.toggle('is-active', on);
        if (on) matched = true;
      });
      // A child with no image of its own leaves the previous one showing
      // rather than blanking the panel.
      if (!matched) figures[0].classList.add('is-active');
    }

    links.forEach(function (link) {
      var handle = link.getAttribute('data-owala-mega-link');
      link.addEventListener('mouseenter', function () {
        show(handle);
      });
      link.addEventListener('focus', function () {
        show(handle);
      });
    });
  });

  /* ---------- 4. Light / dark toggle ------------------------------------
   * The mode is resolved in an inline head script so there is no flash; this
   * only handles switching it and keeping the control's label truthful.
   */

  function applyLabel(btn, isDark) {
    btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    var label = btn.querySelector('.owala-theme-toggle__label');
    if (label) label.textContent = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  }

  document.querySelectorAll('[data-owala-theme-toggle]').forEach(function (btn) {
    var root = document.documentElement;
    applyLabel(btn, root.getAttribute('data-owala-theme') === 'dark');

    btn.addEventListener('click', function () {
      var isDark = root.getAttribute('data-owala-theme') === 'dark';
      if (isDark) {
        root.removeAttribute('data-owala-theme');
      } else {
        root.setAttribute('data-owala-theme', 'dark');
      }
      try {
        localStorage.setItem('owala-theme', isDark ? 'light' : 'dark');
      } catch (e) {
        /* Choice simply will not persist if storage is unavailable. */
      }
      applyLabel(btn, !isDark);
      // The overlay header recolours with the palette, so re-sync it.
      if (typeof sync === 'function') sync();
    });
  });
})();
